import api from '../irelandApi'
import {toast} from "react-toastify";
import ToastMessage from "../components/common/toast-message";
import React from 'react';

export const getDataImportIndex = () => (dispatch) => {
    dispatch({type: 'GET_DATA_IMPORT_LIST_PENDING'});
    return api.get('/api/admin/data_imports')
        .then((response) => {
            dispatch({type: 'GET_DATA_IMPORT_LIST_FULFILLED', payLoad: response.data});
        }).catch((e) => {
            dispatch({type: 'GET_DATA_IMPORT_LIST_REJECTED', payLoad: e});
        })
};

export const importFiles = (files) => (dispatch) => {
    dispatch({type: 'POST_IMPORT_PENDING'});
    return api.post('/api/admin/data_imports', {file_names: files})
        .then((response) => {
            dispatch({type: 'POST_IMPORT_FULFILLED', payLoad: files});
            dispatch({type: 'DELETE_IMPORT_FILES_FULFILLED', payLoad: files})
        }).catch((error) => {
            error.response.data.errors.forEach(value => {
                dispatch({type: 'ADD_TO_HISTORY', payLoad: {import_history: value}});
                dispatch({type: 'DELETE_IMPORT_FILES_FULFILLED', payLoad: [value.upload_name]});
                toast.error(<ToastMessage iconStyle="error" message={value.upload_name + ": " + value.fail_reason}/>);
            });
        })
};

export const getUploadedFile = (id) => (dispatch) => {
    dispatch({type: 'GET_UPLOADED_FILE_PENDING'});
    return api.get('/api/admin/data_imports/' + id)
        .then((response) => {
            dispatch({type: 'GET_UPLOADED_FILE_FULFILLED', payLoad: response.data});
            toast.success(<ToastMessage iconStyle="success" message={response.data.import_history.upload_name + " successfully imported."}/>);
        }).catch(() => {
            dispatch({type: 'GET_UPLOADED_FILE_REJECTED', payLoad: "Error, cannot get upload history."});
        })
};


export const deleteImportableFiles = (files) => (dispatch) => {
    return api.delete('/api/admin/data_imports', {params: {file_names: files}})
        .then((response) => {
            dispatch({type: 'DELETE_IMPORT_FILES_FULFILLED', payLoad: files});
        }).catch(() => {
            dispatch({type: 'DELETE_IMPORT_FILES_REJECTED', payLoad: "Cannot, delete import files."});
        })
};


// WEBPACK FOOTER //
// ./src/actions/data-import.js